/**
 * Updates body classes based on the user's role
 * This function is called on page load and when session storage changes
 */
export function updateBodyClasses() {
  const userType = sessionStorage.getItem('user_type') || '';
  const isParent = sessionStorage.getItem('is_parent') === 'true';
  
  // First remove all user type classes
  document.body.classList.remove('is_parent', 'is_player', 'is_coach');
  
  // Then add the appropriate class
  if (isParent || userType === 'parent') {
    document.body.classList.add('is_parent');
  } else if (userType === 'coach') {
    document.body.classList.add('is_coach');
  } else if (userType === 'player' || userType === '') { // Default to player
    document.body.classList.add('is_player');
  }
}

// Apply body classes on script load
updateBodyClasses();

// Set up a MutationObserver to detect when DOM is ready
const observer = new MutationObserver((mutations) => {
  if (document.body) {
    updateBodyClasses();
    observer.disconnect();
  }
});

// Start observing
observer.observe(document.documentElement, {
  childList: true,
  subtree: true
});

// Create a custom event listener for storage changes
window.addEventListener('storage', () => {
  updateBodyClasses();
});

// Make the function globally available
window.updateBodyClasses = updateBodyClasses; 